import { css, Theme } from '@emotion/react';
import { ColorVariant } from '../colors';

/** Apply a shadow effect to an element to give it depth. */
export const shadow = (color: ColorVariant = 'lightGray') => ({ colors, layout }: Theme) =>
  css({ boxShadow: `0 0 0 ${layout.shadowSize}px ${colors.shadow(color)}` });
